<!-- src/app/drawing-canvas/drawing-canvas.component.html -->
<div class="drawing-dialog">
    <h2 mat-dialog-title>Draw Something</h2>
    <mat-dialog-content class="mat-typography">
        <div class="canvas-container">
            <canvas #drawingCanvas class="drawing-area"></canvas>
        </div>
        <div class="controls">
            <div class="color-palette">
                <span class="palette-label">Color:</span>
                <button *ngFor="let color of colors" mat-icon-button [style.background-color]="color" (click)="selectColor(color)" [class.selected-color]="color === selectedColor" class="color-swatch">
                    <mat-icon *ngIf="color === selectedColor">check</mat-icon>
                </button>
                <input type="color" [(ngModel)]="selectedColor" (change)="selectColor(selectedColor)" class="color-picker-input">
            </div>
            <div class="line-width-control">
                <label for="lineWidthSlider">Line Width:</label>
                <mat-slider min="1" max="10" step="1" discrete="true" showTickMarks>
                    <input matSliderThumb [(ngModel)]="brushSize">
                </mat-slider>
                <span>{{ brushSize }}px</span>
            </div>
            <div class="brush-size-control">
                <label for="brushSizeSlider">Brush Size:</label>
                <mat-slider min="1" max="20" step="1" discrete="true" showTickMarks>
                    <input matSliderThumb [(ngModel)]="brushSize">
                </mat-slider>
                <span>{{ brushSize }}px</span>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button (click)="clearCanvas()">Clear</button>
        <button mat-button (click)="closeDialog()">Cancel</button>
        <button mat-raised-button color="primary" (click)="done()">Done</button>
    </mat-dialog-actions>
</div>

<!-- Add some basic styling -->
<style>
    /* Component-level styles */
    .drawing-dialog {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
    }

    .canvas-container {
        border: 1px solid #ccc;
        margin-bottom: 15px;
        touch-action: none;
        width: 100%;
        height: 65vh;
        /* Make canvas take up 65% of viewport height */
        box-sizing: border-box;
    }

    .drawing-area {
        display: block;
        background-color: #fff;
        width: 100%;
        height: 100%;
    }

    .controls {
        display: flex;
        flex-direction: column;
        gap: 15px;
        margin-top: 10px;
        margin-bottom: 20px;
        /* Ensure space before actions */
        flex-shrink: 0;
    }

    /* Color palette styles */
    .color-palette {
        display: flex;
        align-items: center;
        gap: 5px;
        flex-wrap: wrap;
    }

    .palette-label {
        margin-right: 5px;
        font-weight: 500;
    }

    .color-swatch {
        width: 24px;
        height: 24px;
        min-width: 24px;
        /* Override default mat-icon-button min-width */
        padding: 0;
        border: 1px solid #ccc;
        border-radius: 50%;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        color: rgba(0, 0, 0, 0.5);
        /* Icon color */
    }

    .color-swatch.selected-color {
        border: 2px solid #000;
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
    }

    .color-swatch mat-icon {
        font-size: 18px;
        height: 18px;
        width: 18px;
        line-height: 18px;
        /* Mix blend mode to make checkmark visible on light/dark colors */
        mix-blend-mode: difference;
        filter: invert(1) grayscale(1) contrast(100);
    }

    .color-picker-input {
        width: 30px;
        height: 30px;
        border: none;
        padding: 0;
        cursor: pointer;
        background: none;
        margin-left: 5px;
    }

    /* Line width control styles */
    .line-width-control {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .line-width-control mat-slider {
        flex-grow: 1;
        max-width: 200px;
    }

    .line-width-control label {
        font-weight: 500;
    }

    .line-width-control span {
        min-width: 30px;
        /* Ensure space for text */
        text-align: right;
    }

    /* Ensure dialog content area behaves properly */
    mat-dialog-content {
        display: flex;
        flex-direction: column;
        max-height: unset !important;
        /* Override Material's default max-height */
        flex: 1;
        min-height: 0;
        overflow-y: auto;
        padding-bottom: 20px !important;
        /* Force padding at bottom */
    }

    /* Ensure mat-dialog-actions is visible */
    mat-dialog-actions {
        flex-shrink: 0;
        visibility: visible !important;
        position: relative;
        /* Ensure it participates in normal flow */
        bottom: 0;
        padding: 12px 0;
        margin-bottom: 0 !important;
        border-top: 1px solid #eee;
        background: white;
    }
</style>

<!-- Global styles for the Material Dialog container -->
<style>
    /* Target the custom class we added to the dialog container */
    .drawing-dialog-container .mat-mdc-dialog-surface {
        display: flex;
        flex-direction: column;
        max-height: 90vh !important;
        max-width: none !important;
    }

    /* Ensure dialog content fills available space */
    .drawing-dialog-container .mat-mdc-dialog-content {
        max-height: none !important;
        display: flex;
        flex-direction: column;
        flex: 1;
    }

    /* Ensure action buttons are visible */
    .drawing-dialog-container .mat-mdc-dialog-actions {
        min-height: 52px;
        padding: 8px 24px;
        justify-content: flex-end;
        position: relative;
        border-top: 1px solid rgba(0, 0, 0, 0.12);
        margin-bottom: 0 !important;
        margin-top: auto !important;
    }

    /* Fix for Safari and some other browsers */
    @supports (-webkit-touch-callout: none) {
        .drawing-dialog-container .mat-mdc-dialog-actions {
            position: sticky;
            bottom: 0;
            background: white;
            z-index: 1;
        }
    }
</style>